<template>
	<div>
		<el-dialog
			title="已入库确认"
			:visible.sync="dialogVisible"
			width="500px"
		>
			<span>请确认旧机再生资源已入库</span>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="confirmBtnFun" :loading="btnLoadFlag">确 认</el-button>
        <el-button @click="cancelBtnFun">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			dialogVisible: false,
      btnLoadFlag: false
		}
	},
  methods: {
    // 打开弹框
    opendDialog (orderNo) {
      this.orderNo = orderNo
      this.dialogVisible = true
    },
    // 取消弹框
    cancelBtnFun () {
      this.dialogVisible = false
    },
    // 确认
    confirmBtnFun () {
      this.btnLoadFlag = true
      const url = `/autoapp-default-server-recovery/api/jd/recycle/order/warehousing/${this.orderNo}`
      this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          // console.log('res===', res)
          this.$message.success('入库成功')
          this.$emit('opera-success')
					this.dialogVisible = false
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
        this.btnLoadFlag = false
      })
    }
  },
}
</script>
<style scoped lang="scss">
.dialog-footer{
  padding: 16px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/views/jdOldMachineRecycleManage/components/InStoreConfirmDialog.vue